import React from 'react';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import { FormattedMessage } from 'react-intl';

import { GUIDANCE_CONTROL_ATTACHMENT } from 'yeself-common/typings/application/ApplicationEnum';

type AttachmentValue = typeof GUIDANCE_CONTROL_ATTACHMENT[keyof typeof GUIDANCE_CONTROL_ATTACHMENT];

type GuidanceControlAttachmentFormProps = {
    onChange: (value: AttachmentValue) => void;
    value: AttachmentValue;
    classNames: {
        itemTextClassName?: string;
        textField?: string;
        cssSelectRoot?: string;
        cssUnderline?: string;
        menu?: string;
        formInput?: string;
    };
};

const GuidanceControlAttachmentForm = ({
    onChange,
    value,
    classNames = {},
}: GuidanceControlAttachmentFormProps): React.ReactElement => (
    <Grid container alignItems="center" style={{ paddingBottom: '20px' }}>
        <Typography variant="subtitle1" className={classNames.itemTextClassName}>
            <FormattedMessage
                id="ContextHelp.guidanceControl.attachment.title"
                defaultMessage="The Guidance control will be displayed in"
            />
        </Typography>
        <Grid id="yeself-guidance-control-dropdown" item className={classNames.formInput}>
            <TextField
                value={value}
                onChange={(event) => onChange(event.target.value as AttachmentValue)}
                select
                fullWidth={false}
                className={classNames.textField}
                margin="normal"
                variant="filled"
                InputProps={{
                    classes: {
                        root: classNames.cssSelectRoot,
                        underline: classNames.cssUnderline,
                    },
                }}
                SelectProps={{
                    MenuProps: {
                        className: classNames.menu,
                    },
                }}
            >
                {Object.values(GUIDANCE_CONTROL_ATTACHMENT).map((option) => (
                    <MenuItem value={option} key={option}>
                        <FormattedMessage
                            id={`ContextHelp.guidanceControl.attachment.options.${option}`}
                        />
                    </MenuItem>
                ))}
            </TextField>
        </Grid>
    </Grid>
);

export default GuidanceControlAttachmentForm;
